import PropTypes from 'prop-types';

export const linkPropType = PropTypes.shape({
  href: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  text: PropTypes.string.isRequired,
  logging: PropTypes.func,
});

export const productPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  ctaLink: linkPropType,
  learnMoreLink: linkPropType,
});

export const productCategoryPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  priority: PropTypes.number,
  products: PropTypes.arrayOf(productPropType).isRequired,
});

export const menuItemPropType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
  target: PropTypes.string,
  logging: PropTypes.func,
});
